import React, {  useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./LoBanner.css";
import htmlParser from "html-react-parser";

import ContactUsForm from "../ContactUS Form/ContactUsForm";
import Header from "../Header/index";

export default function Banner({ lobannerData, loanOfficer, loInformation, loanRealtor, }) {
  const [navbar, setNavbar] = useState(false);

  //logo scroll when active

  function scrollToSection1() {
    const sectionPosition =
      document.getElementById("contact-wrapper").offsetTop;
    window.scrollTo({
      top: sectionPosition,
      behavior: "smooth",
    });
  }
  
  const imgCDNURL = process.env.REACT_APP_CDN_URL;
  return (
    <>
      <div className="bannerbglo">
        <Container className="pt-3">
          <Header />
          <Row>
            <Col sm={12} md={12} lg={7} xl={7} className="dpaHeadingcol">
              <h4 className="dpaheadinglo">
                {htmlParser(lobannerData.bannerHeading)}
              </h4>
              <div className="maindivofdivlo">
                <div className="topidiv">
                  <img
                    src={imgCDNURL + "homecap.webp"}
                    className="img-fluid homecallo"
                    alt="homecap"
                  ></img>
                </div>
                <div className="ignoremacediv">
                  <h4 className="dpaheadingorancelo">
                    {htmlParser(lobannerData.bannermobHeading)}
                  </h4>
                </div>
              </div>
              {/* <h4 className="dpaheadingorance">
                {htmlParser(lobannerData.bannermobHeading)}
              </h4> */}
              <div>
              <img
                    src={imgCDNURL + "planearrow.webp"}
                    className="img-fluid planearrows"
                    alt="planearrows"
                  ></img>
              </div>
<div className="planearrowdiv">
              <h4 className="secondsmallhead">
                {htmlParser(lobannerData.bannerSubHeading2)}
              </h4>

          {/* Conditional rendering of names */}
          {loanRealtor ? (
                  <>
                    <h4 className="loheadingname">{htmlParser(loanOfficer.Name)}</h4>
                    <h4 className="loheadingnameand">and</h4>
                    <h4 className="loheadingname">{htmlParser(loanRealtor.Name)}</h4>
                  </>
                ) : (
                  <h4 className="loheadingname">{htmlParser(loanOfficer.Name)}</h4>
                )}
              </div>
            </Col>

            <Col sm={12} md={12} lg={5} xl={5} id="contactus">
              <ContactUsForm
                loanOfficer={loanOfficer}
                loInformation={loInformation}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
